<script>
	const model = require('model/model');
	const utilities = require('utilities');

	const studentLibraryUtilities = require('utilities/studentLibraryUtilities');
	const addFavorite = studentLibraryUtilities.addFavorite;
	const removeFavorite = studentLibraryUtilities.removeFavorite;
	const addReadingList = studentLibraryUtilities.addReadingList;
	const removeReadingList = studentLibraryUtilities.removeReadingList;

	const analyticsUtilities = require('utilities/analyticsUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const SL_BOOKMARK = analyticsUtilities.events.SL_BOOKMARK;
	const SL_FAVORITE = analyticsUtilities.events.SL_FAVORITE;
	const SL_ARTICLE_VIEW = analyticsUtilities.events.SL_ARTICLE_VIEW;

	module.exports = {
		components: {
			'article-image': require('components/article-image.vue').default,
			'load-mask': require('components/load-mask.vue').default,
			'bookmark-icon': require('components/svg/bookmark-icon.vue').default,
			'heart-icon': require('components/svg/heart-icon.vue').default,
			'checkbox-icon': require('components/svg/checkbox-icon.vue').default
		},
		props: {
			id: {
				default: null
			},
			img: {
				default: null
			},
			title: {
				default: null
			},
			topics: {
				default: null
			},
			level: {
				default: null
			},
			horizontal: {
				default: false
			},
			showReadingList: {
				default: true
			},
			showRead: {
				default: true
			},
			showFavorite: {
				default: false
			},
			loading: {
				default: false
			},
			carousel: {
				default: undefined
			},
			articleIndex: {
				default: undefined,
				type: Number
			},
			versioned: {
				default: false
			},
			link: {
				default: true
			},
			onProductClick: {
				type: Function
			},
			onBookmarkClick: {
				type: Function
			},
			location: {
				default: null
			},
			imgAlt: {
				type: String
			}
		},
		modelData: ['libraryProducts', 'userContext', 'libraryView', 'q', 't'],
		data() {
			return {
				internalLoading: false
			};
		},
		computed: {
			isLoading() {
				return this.loading || this.internalLoading;
			},
			uuid() {
				let id = this.id;
				let result = id;
				let parse = utilities.parseProductUUIDAndVersion(id);

				if (parse && parse.uuid) {
					result = parse.uuid;
				}

				return result;
			},
			libraryProduct() {
				let libraryProducts = this.libraryProducts;
				let uuid = this.uuid;
				let result = null;

				if (uuid && libraryProducts && libraryProducts[uuid]) {
					result = libraryProducts[uuid];
				}
				return result;
			},
			favorite() {
				let libraryProduct = this.libraryProduct;
				let result = null;
				if (libraryProduct) {
					result = libraryProduct.favorite;
				}
				return result;
			},
			recommended() {
				let libraryProduct = this.libraryProduct;
				let result = null;
				if (libraryProduct) {
					result = libraryProduct.recommended;
				}
				return result;
			},
			read() {
				let libraryProduct = this.libraryProduct;
				let result = null;
				if (libraryProduct) {
					result = libraryProduct.read;
				}
				return result;
			},
			readNext() {
				let libraryProduct = this.libraryProduct;
				let result = null;
				if (libraryProduct) {
					result = libraryProduct.readNext;
				}
				return result;
			},
			isTeacher() {
				return this.userContext && !this.userContext.classCode;
			},
			href() {
				let versioned = this.versioned;
				let uuid = this.uuid;
				let libraryProduct = this.libraryProduct;
				let pid = (libraryProduct && libraryProduct.id) || this.id;
				let q = this.q;
				let t = this.t;
				let id = versioned ? pid : uuid;

				if (!this.link) {
					return '';
				}

				let url = '#!productId:' + id + '/libraryView:content/';
				if (q || t) {
					let typeString = '';
					if (t && t.length) {
						typeString = t.join(',');
					}
					url += 'q:' + q + '/t:' + typeString + '/';
				}
				return url;
			}
		},
		methods: {
			onProductClickInternal(event) {
				const uuid = this.uuid;
				const versioned = this.versioned;
				const libraryProduct = this.libraryProduct;
				const pid = (libraryProduct && libraryProduct.id) || this.id;
				const articleIndex = (this.articleIndex && this.articleIndex + 1) || 1;
				const level = this.level;

				if (this.onProductClick) {
					this.onProductClick(event, pid || uuid, articleIndex, level);
				} else {
					fireEvent(SL_ARTICLE_VIEW, {
						pid: uuid,
						bookmark: libraryProduct ? libraryProduct.readNext : false,
						favorite: libraryProduct ? libraryProduct.favorite : false,
						read: libraryProduct ? libraryProduct.read : false,
						loc: this.location || this.libraryView,
						carousel: this.carousel,
						articleIndex,
						level
					});
					const productId = (versioned && pid) || uuid;
					model.set({
						productId,
						libraryView: 'content'
					});
				}
			},
			addToFavoriteList() {
				let uuid = this.uuid;
				this.internalLoading = true;
				fireEvent(SL_FAVORITE, {
					pid: uuid,
					value: true,
					loc: this.location || this.libraryView,
					carousel: this.carousel
				});
				addFavorite(uuid).then(() => (this.internalLoading = false));
			},
			removeFromFavoriteList() {
				let uuid = this.uuid;
				this.internalLoading = true;
				fireEvent(SL_FAVORITE, {
					pid: uuid,
					value: false,
					loc: this.location || this.libraryView,
					carousel: this.carousel
				});
				removeFavorite(uuid).then(() => (this.internalLoading = false));
			},
			addToReadingList(e) {
				let uuid = this.uuid;
				this.internalLoading = true;
				if (this.onBookmarkClick) {
					this.onBookmarkClick(e, uuid);
				}
				fireEvent(SL_BOOKMARK, {
					pid: uuid,
					value: true,
					loc: this.location || this.libraryView,
					carousel: this.carousel
				});
				addReadingList(uuid).then(() => (this.internalLoading = false));
			},
			removeFromReadingList(e) {
				let uuid = this.uuid;
				this.internalLoading = true;
				if (this.onBookmarkClick) {
					this.onBookmarkClick(e, uuid);
				}
				fireEvent(SL_BOOKMARK, {
					pid: uuid,
					value: false,
					loc: this.location || this.libraryView,
					carousel: this.carousel
				});
				removeReadingList(uuid).then(() => (this.internalLoading = false));
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';
	@import 'config/colors';

	.library-product-card {
		display: inline-block;
		width: 10rem;
		margin: 0 2rem 2rem 0;
		border-width: 0px;
		position: relative;
		// border-radius: 1rem 1rem 0 0;

		.product-image {
			cursor: pointer;
			position: relative;

			.read {
				position: absolute;
				right: 0;
				bottom: 0;
				display: block;
				background-color: $c-white;
				padding: 0.5rem 0.5rem 0.75rem 0.5rem;

				svg {
					stroke: $c-green;
					fill: $c-green;
				}

				&.favorite {
					svg {
						stroke: $c-red;
						fill: none;
					}
				}
			}

			.article-image .article-featured-image-container {
				height: 10rem;
				width: 100%;

				figure.article-featured-image {
					border-radius: 0rem;
				}
			}
		}

		.product-body {
			padding: 0 0.5rem;

			.product-title {
				cursor: pointer;
				color: $c-blue;
			}

			.product-topics,
			.product-meta {
				font-size: 0.75rem;
			}

			.reading-list-button {
				cursor: pointer;

				.bookmark-icon {
					stroke-width: 2px;

					&.active {
						stroke: $c-blue-dark;
						fill: $c-blue-dark;

						&:hover {
							color: $c-blue-dark;
						}
					}
				}

				&:hover {
					color: $c-blue-dark;

					.bookmark-icon {
						stroke: $c-blue-dark;
					}
				}
			}

			.favorite-list-button {
				cursor: pointer;

				.heart-icon {
					stroke-width: 2px;

					&.active {
						stroke: $c-red;

						&:hover {
							color: $c-red;
						}
					}
				}

				&:hover {
					color: $c-red;

					.heart-icon {
						stroke: $c-red;
					}
				}
			}
		}

		&:hover {
			// box-shadow: 2px 2px 4px $c-grey;

			.product-title {
				color: $c-slate-dark;
			}
		}

		&.horizontal {
			display: flex;
			width: 100%;

			.product-image {
				.article-image .article-featured-image-container {
					width: 10rem;
				}
			}
		}
	}
</style>
<template>
	<div
		class="library-product-card"
		:class="{ horizontal }">
		<load-mask v-if="isLoading"></load-mask>
		<a
			class="product-image"
			v-if="img"
			@click.prevent="onProductClickInternal"
			:href="href">
			<article-image
				:image-url="img"
				:alt-text="imgAlt"></article-image>
			<div
				class="read"
				:class="{
					favorite: favorite
				}"
				v-if="showRead && read">
				<checkbox-icon v-if="!favorite"></checkbox-icon>
				<heart-icon v-if="favorite"></heart-icon>
			</div>
		</a>
		<div class="product-body">
			<a
				class="product-title"
				@click.prevent="onProductClickInternal"
				v-if="title"
				:href="href">
				{{ title }}
			</a>
			<div class="product-meta">
				<div
					class="product-topics"
					v-if="topics">
					{{ topics }}
				</div>
				<button
					v-if="!isTeacher && read && showFavorite"
					class="favorite-list-button button -link"
					:aria-label="`${favorite ? 'Remove' : 'Add'} Favorite `"
					:aria-describedby="title"
					@click="favorite ? removeFromFavoriteList(id) : addToFavoriteList(id)">
					<heart-icon
						:class="{
							active: favorite
						}"></heart-icon>
				</button>
				<button
					v-if="!isTeacher && showReadingList && !read"
					class="reading-list-button button -link"
					:aria-label="`${readNext ? 'Remove from' : 'Add to'} reading list`"
					:aria-describedby="title"
					@click="readNext ? removeFromReadingList(id) : addToReadingList(id)">
					<bookmark-icon
						:class="{
							active: readNext
						}"></bookmark-icon>
				</button>
				<slot></slot>
			</div>
		</div>
	</div>
</template>
